var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0625 13C18.8958 12.1667 19.3125 11.1667 19.3125 10C19.3125 8.54167 18.7917 7.29167 17.75 6.25C16.7083 5.20833 15.4583 4.6875 14 4.6875C12.5417 4.6875 11.2917 5.20833 10.25 6.25C9.20833 7.29167 8.6875 8.54167 8.6875 10H11.3125C11.3125 9.29167 11.5833 8.66667 12.125 8.125C12.6667 7.58333 13.2917 7.3125 14 7.3125C14.7083 7.3125 15.3333 7.58333 15.875 8.125C16.4167 8.66667 16.6875 9.29167 16.6875 10C16.6875 10.7083 16.4167 11.3333 15.875 11.875L14.25 13.5625C13.2083 14.6875 12.6875 15.9375 12.6875 17.3125V18H15.3125C15.3125 16.625 15.8333 15.375 16.875 14.25L18.0625 13ZM15.3125 23.3125V20.6875H12.6875V23.3125H15.3125ZM4.5625 4.625C7.1875 2 10.3333 0.6875 14 0.6875C17.6667 0.6875 20.7917 2 23.375 4.625C26 7.20833 27.3125 10.3333 27.3125 14C27.3125 17.6667 26 20.8125 23.375 23.4375C20.7917 26.0208 17.6667 27.3125 14 27.3125C10.3333 27.3125 7.1875 26.0208 4.5625 23.4375C1.97917 20.8125 0.6875 17.6667 0.6875 14C0.6875 10.3333 1.97917 7.20833 4.5625 4.625Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.68b0f7696e134393d799bb1b69011e7c.svg";
export { ForwardRef as ReactComponent };